/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.redeemAmazonCatalogueItem.internal

import features.redeemAmazonCatalogueItem.models.RedeemAmazonItemRequest
import features.redeemAmazonCatalogueItem.models.RedeemResponseModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.redeemAmazonCatalogueItem.internal.RedeemAmazonCatalogueItemsUseCase.Params

internal class RedeemAmazonCatalogueItemsUseCase : AsyncUseCase<RedeemResponseModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val redeemAmazonItemRequest: RedeemAmazonItemRequest
    )

    private val redeemAmazonCatalogueItemsService: RedeemAmazonCatalogueItemsService = RedeemAmazonCatalogueItemsServiceImpl()

    override suspend fun run(params: Params): Result<RedeemResponseModel> {
        return redeemAmazonCatalogueItemsService.redeemAmazonCatalogueItem(
            overrideHeaders = params.overrideHeaders,
            redeemAmazonItemRequest = params.redeemAmazonItemRequest
        )
    }
}
